import {
  NEXT_CREATE_STAGE,
  PREVIOUS_CREATE_STAGE,
  RESET_STEPS,
  SELECT_SERVICE,
  SELECT_SERVICE_SUBTYPE,
  SELECT_VERSION,
  SELECT_REGION,
  SELECT_PROVIDER,
  ENTER_NAME,
  SELECT_FLAVOR,
  SELECT_ADDON,
  DESELECT_ADDON,
  SELECT_PLAN,
  ENTER_CIDR,
  ENTER_ACL_NAME,
  SELECT_ACL_KIND,
  ADD_ACL,
  REMOVE_ACL,
  ADD_IPS_LATER,
  CREATEINSTANCE_REQUESTED,
  CREATEINSTANCE_SUCCESS,
  CREATEINSTANCE_FAILURE,
  RESET_CREATEINSTANCE_ERROR_STATE,
  GETIP_REQUESTED,
  GETIP_SUCCESS,
  GETIP_FAILURE,
  GETIP_CLEAR,
  GET_PRICE_REQUESTED,
  GET_PRICE_SUCCESS,
  GET_PRICE_FAILURE,
} from '../actions';

export const initialState = {
  activeStep: 0,
  addIpsLater: false,
  isLoading: false,
  error: null,
  myip: null,
  newInstance: {
    newInstanceName: '',
    newInstanceService: {},
    newInstanceServiceSubtype: {},
    newInstanceVersion: '0',
    newInstanceRegion: '0',
    newInstanceCloudProvider: {},
    newInstanceFlavorIndex: -1,
    newInstanceAddons: [],
    newInstancePlan: {},
    newInstancePlanIndex: 0,
    newInstanceAcls: [],
  },
  price: 0,
};

export default function createInstanceReducer(state = initialState, action) {
  switch (action.type) {
    case NEXT_CREATE_STAGE:
      return { ...state, activeStep: action.payload };

    case PREVIOUS_CREATE_STAGE:
      return { ...state, activeStep: action.payload };

    case RESET_STEPS:
      return {
        ...initialState,
      };

    case SELECT_SERVICE:
      return {
        ...state,
        newAcl: {},
        newInstance: {
          ...initialState.newInstance,
          newInstanceService: action.payload.selectedService,
          newInstanceServiceSubtype: action.payload.defaultSubtype,
          newInstanceCloudProvider: action.payload.defaultCloudProvider,
          newInstanceName: state.newInstance.newInstanceName,
          newInstanceFlavorIndex: initialState.newInstance.newInstanceFlavorIndex,
          newInstancePlan: initialState.newInstance.newInstancePlan,
          newInstancePlanIndex: initialState.newInstance.newInstancePlanIndex,
        },
      };

    case SELECT_SERVICE_SUBTYPE:
      return {
        ...state,
        newAcl: {},
        newInstance: {
          ...state.newInstance,
          newInstanceServiceSubtype: action.payload,
          newInstanceVersion: initialState.newInstance.newInstanceVersion,
          newInstanceFlavorIndex: initialState.newInstance.newInstanceFlavorIndex,
          newInstancePlan: initialState.newInstance.newInstancePlan,
          newInstancePlanIndex: initialState.newInstance.newInstancePlanIndex,
        },
      };

    case SELECT_VERSION:
      return {
        ...state,
        newInstance: { ...state.newInstance, newInstanceVersion: action.payload },
      };

    case SELECT_REGION:
      return { ...state, newInstance: { ...state.newInstance, newInstanceRegion: action.payload } };

    case ENTER_NAME:
      return { ...state, newInstance: { ...state.newInstance, newInstanceName: action.payload } };

    case SELECT_PROVIDER:
      return {
        ...state,
        newAcl: {},
        newInstance: {
          ...state.newInstance,
          newInstanceCloudProvider: action.payload,
        },
      };

    case SELECT_FLAVOR:
      return {
        ...state,
        newInstance: {
          ...state.newInstance,
          newInstanceFlavorIndex: action.payload.value,
          newInstancePlan: action.payload.defaultPlan,
          newInstancePlanIndex: 0,
        },
      };
    // here
    case SELECT_ADDON:
      return {
        ...state,
        newInstance: {
          ...state.newInstance,
          newInstanceAddons: [
            ...state.newInstance.newInstanceAddons.filter(
              (addon) => addon.id !== action.payload.id,
            ),
            action.payload,
          ],
        },
      };

    case DESELECT_ADDON:
      return {
        ...state,
        newInstance: {
          ...state.newInstance,
          newInstanceAddons: state.newInstance.newInstanceAddons.filter(
            (addon) => addon.id !== action.payload,
          ),
        },
      };

    case SELECT_PLAN:
      return {
        ...state,
        newInstance: {
          ...state.newInstance,
          newInstancePlanIndex: action.payload.planIndex,
          newInstancePlan: action.payload.plan,
        },
      };

    case ENTER_CIDR:
      return {
        ...state,
        newAcl: { ...state.newAcl, cidr: action.payload },
      };

    case ENTER_ACL_NAME:
      return { ...state, newAcl: { ...state.newAcl, name: action.payload } };

    case SELECT_ACL_KIND:
      return {
        ...state,
        newAcl: { ...state.newAcl, kind: action.payload },
      };

    case ADD_ACL:
      return {
        ...state,
        newInstance: {
          ...state.newInstance,
          newInstanceAcls: [...state.newInstance.newInstanceAcls, action.payload],
        },
        newAcl: {},
        addIpsLater: false,
      };

    case REMOVE_ACL:
      // eslint-disable-next-line no-case-declarations
      const newInstanceAcls = state.newInstance.newInstanceAcls.slice();
      newInstanceAcls.splice(action.payload, 1);

      return {
        ...state,
        newInstance: {
          ...state.newInstance,
          newInstanceAcls,
        },
      };

    case ADD_IPS_LATER:
      return {
        ...state,
        addIpsLater: !state.addIpsLater,
        newInstance: {
          ...state.newInstance,
          newInstanceAcls: initialState.newInstance.newInstanceAcls,
        },
      };

    case GETIP_REQUESTED:
      return {
        ...state,
        myip: null,
      };

    case GETIP_SUCCESS:
      return {
        ...state,
        myip: action.payload.ip,
      };

    case GETIP_FAILURE:
      return {
        ...state,
        myip: null,
        error: action.payload.message,
      };

    case GETIP_CLEAR:
      return {
        ...state,
        myip: null,
      };

    case CREATEINSTANCE_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: initialState.error,
      };

    case CREATEINSTANCE_SUCCESS:
      return {
        ...initialState,
      };

    case CREATEINSTANCE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case RESET_CREATEINSTANCE_ERROR_STATE:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PRICE_REQUESTED:
      return {
        ...state,
      };

    case GET_PRICE_SUCCESS:
      return {
        ...state,
        price: action.payload.priceInCents,
      };

    case GET_PRICE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
}
